export const disciplines = [
  "Strategy",
  "Execution",
  "People",
  "Board & Advisors",
  "Sales & Marketing",
  "Operations",
  "Finance",
  "Capital",
];

export const ProjectAcceptFiles =
  ".art,.bat,.brf,.c,.cls,.css,.diff,.eml,.es,.h,.hs,.htm,.html,.ics,.ifb,.java,.js,.json,.ksh,.ltx,.mail,.markdown,.md,.mht,.mhtml,.mjs,.nws,.patch,.pdf,.pl,.pm,.pot,.py,.rst,.scala,.sh,.shtml,.srt,.sty,.tex,.text,.txt,.vcf,.vtt,.xml,.yaml,.yml,.png,.jpg,.jpeg,.webp";
